// extracted by mini-css-extract-plugin
export default {"title":"title--T16tv","form":"form--CHLPh"};